﻿export type ResultatValg = ResultatValgVisning;

export interface ResultatValgVisning {
    visInntektOgBarn: boolean;
    visResultatCa: boolean;
    visResultatCb: boolean;
    visGenerellFeil: boolean;
}

export const SET_VISNING = 'SET_VISNING';

export interface SetVisningAction {
    type: typeof SET_VISNING;
    payload: Partial<ResultatValgVisning>;
}

export type ResultatActionTypes = SetVisningAction;
